"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TowingAComet = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
var CardRenderer_1 = require("../render/CardRenderer");
var TowingAComet = (function (_super) {
    __extends(TowingAComet, _super);
    function TowingAComet() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.TOWING_A_COMET,
            tags: [Tags_1.Tags.SPACE],
            cost: 23,
            tr: { oxygen: 1, oceans: 1 },
            metadata: {
                cardNumber: '075',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.oxygen(1).oceans(1).br;
                    b.plants(2);
                }),
                description: 'Gain 2 plants. Raise oxygen level 1 step and place an ocean tile.',
            },
        }) || this;
    }
    TowingAComet.prototype.play = function (player) {
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
        player.plants += 2;
        return player.game.increaseOxygenLevel(player, 1);
    };
    return TowingAComet;
}(Card_1.Card));
exports.TowingAComet = TowingAComet;
